import {
  ADMIN_LOGOUT,
  ADMIN_LOGOUT_SUCCESS,
  ADMIN_LOGOUT_FAILURE,
} from 'store/AdminLogout/AdminLogoutAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const adminLogoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_LOGOUT:
      return { ...state, loading: true };
    case ADMIN_LOGOUT_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case ADMIN_LOGOUT_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default adminLogoutReducer;
